import React from 'react';
import { CarTitle as AuiCarTitle } from '@azgaz/azgaz-ui';
import { Components } from '@/apps/appCreator/outsideComponents';

const CarTitle: Components['CarTitle'] = ({ car }) => {
  return <AuiCarTitle title={car.name} />;
};

export default CarTitle;
